import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { useLoaderDelay } from '@wix/da-ds/pkg/LoadingIndicator/useLoaderDelay';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';
import InfoIcon from '@wix/da-ds/pkg/Icons/16x16/Info';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import s from './LoadingPostfix.scss';
/**
 * An info icon with a tooltip that indicates that we're still loading the estimated earnings. Will start
 * a slow opacity animation if loading takes too long.
 */ const LoadingPostfix = ()=>{
    const { t } = useTranslation();
    const showLoadingAnimation = useLoaderDelay();
    return /*#__PURE__*/ React.createElement(SimpleTooltip, {
        text: t('estimatedEarnings.loading.tooltip')
    }, /*#__PURE__*/ React.createElement(InfoIcon, {
        "aria-label": t('estimatedEarnings.loading.tooltip'),
        size: IconSize.SMALLER,
        className: c(showLoadingAnimation && s['loading-icon']),
        disableDefaultColors: true
    }));
};
LoadingPostfix.displayName = 'LoadingPostfix';
export default LoadingPostfix;

//# sourceMappingURL=LoadingPostfix.js.map